import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WhatsappCampaignService {

  constructor(
    private _http: HttpClient
  ) { }

  addUpdateWhatsappCampaign(data: any):Observable<any> {
    return this._http.post<any>(`${environment.whatsapp}/campaign`, data);
  }

  getAllWhatsappCampaign( pageNumber: any, pageSize:any):Observable<any>{
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 20
    }
    return this._http.post<any>(`${environment.whatsapp}/campaigns`, paginationSettings);
  }

  getWhatsappCampaignById(id:any):Observable<any>{
    return this._http.get<any>(`${environment.whatsapp}/campaign/${id}`);
  }

  getWhatsappTemplates(pageNumber: any, pageSize:any,):Observable<any>{
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 20
    }
    return this._http.post<any>(`${environment.whatsapp}/templates`, paginationSettings);
  }
}
